import { supabase } from "../supabase/SupabaseClient";
import { traerTodas } from "./paginar";

/* A quién va cada correo de la mañana y si ya sale de verdad (ticket #456).
   La tabla la ve y la cambia sólo quien tiene `cargar.satelital` (RLS). De
   acá no sale ningún mail: lo manda él desde su correo. */

export async function traerDestinos() {
  const { data, error } = await supabase.from("satelital_correos").select("clave, para, cc, real, actualizado_por, actualizado_en");
  if (error) throw error;
  return Object.fromEntries((data || []).map((f) => [f.clave, f]));
}

export async function guardarDestino(clave, { para, cc, real }) {
  const { data, error } = await supabase
    .from("satelital_correos")
    .upsert({ clave, para, cc, real }, { onConflict: "clave" })
    .select("clave, para, cc, real, actualizado_por, actualizado_en")
    .single();
  if (error) throw error;
  return data;
}

/* El DNI y el celular de los choferes, para el correo de Car-Truck (ticket
   546). El tractor → DNI sale de `chofer_tractor` (si no se puede leer, queda
   el nombre) y el DNI → celular, de `personas`. */
export async function choferesPadron() {
  const [ct, ps] = await Promise.all([
    supabase.from("chofer_tractor").select("dni, interno").then((r) => r.data || []).catch(() => []),
    traerTodas(() => supabase.from("personas").select("dni, apellido, nombres, telefono", { count: "exact" }).order("id"))
      .catch(() => []),
  ]);
  const porInterno = Object.fromEntries((ct || []).map((f) => [String(f.interno ?? "").trim(), String(f.dni ?? "")]));
  const porDni = Object.fromEntries((ps || []).map((p) => [String(p.dni ?? ""), p]));
  return { porInterno, porDni, personas: ps || [] };
}
